import { Box, TextField } from '@mui/material';
import { FormInputProps } from './FormInput.types';
import FormInputLabel from './FormInputLabel';
import { getNoSpaceInputProps } from 'src/utils/strings/getNoSpaceInputProps';

const FormInput = ({
  tooltipProps,
  label,
  children,
  size = 'medium',
  fullWidth = true,
  error,
  helperText,
  textCase,
  onBlur,
  onInputTrack,
  blockAllSpaces,
  inputProps,
  ...textFieldProps
}: FormInputProps) => {
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e);
    }
    if (onInputTrack) {
      onInputTrack(e.target.name, e.target.value);
    }
  };

  return (
    <Box width={fullWidth ? '100%' : undefined}>
      {label ? (
        typeof label === 'string' ? (
          <FormInputLabel
            inputId={textFieldProps.id}
            required={textFieldProps.required}
            label={label}
            tooltipProps={tooltipProps}
          />
        ) : (
          label
        )
      ) : null}
      <TextField
        size={size}
        FormHelperTextProps={{ sx: { mx: 0.5 } }}
        fullWidth={fullWidth}
        error={error}
        helperText={helperText}
        inputProps={{
          style: { textTransform: !textCase ? undefined : textCase },
          ...(blockAllSpaces && { ...getNoSpaceInputProps() }),
          ...inputProps,
        }}
        onBlur={handleBlur}
        {...textFieldProps}
      >
        {children}
      </TextField>
    </Box>
  );
};

export default FormInput;
